import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { ITimeZonePanelButtonProps } from './types';
import { TIMEZONE_TITLE } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function TimeZonePanelButton ({
    isDisabled,
    tooltip,
    onClick
}: ITimeZonePanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.TIME_ZONE}
            isDisabled={isDisabled}
            title={TIMEZONE_TITLE}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.TIME_ZONE);
                onClick();
            }}
        />
    );
}
